import axios from "axios";

// Order Discount (Sep 2026) — the kiosk / storefront Order Summary is
// server-authoritative. `POST /cart/quote` prices the customer's open cart
// with the backend's one totals engine (`services/commerce.py::
// compute_breakdown`, via `retail/order_pricing.py`) using the same tax
// inputs checkout uses, so the subtotal, tax, delivery, tip and total the
// customer sees are the ones the order will carry.
//
// Only the customer's CHOICES are sent: which cart, which order type, and
// either a percentage tip (`tip_percent`, computed by the server on
// post-discount merchandise) or a custom tip amount. No amount is ever
// computed here. Kept in its own module so a component test can stand in
// for the network call without rewriting its own `axios` sequencing.
export async function fetchOrderSummary({ baseUrl, slug, sessionId, orderType, tipRequest }) {
  const { data } = await axios.post(`${baseUrl}/${slug}/cart/quote`, {
    session_id: sessionId,
    fulfillment_mode: orderType || null,
    ...(tipRequest || {}),
  });
  return data?.summary || null;
}
